import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BusinessContentReducer(state = initialState.businessContent, action: any) {
  switch (action.type) {
    case types.SAVE_BUSINESSCONTENT_SUCCESS:
      return action.businessContent;
    default:
      return state;
  }
}
